import React from 'react';
import useStyle from './changeClassBlock.style';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { openClasseChoice } from 'store/actions/ui.actions';

export const ChangeClassBlock = () => {
  const classes = useStyle();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div
      className={classes.root}
      onClick={() => {
        history.push('/');
        dispatch(openClasseChoice);
      }}
    >
      <p>Changer de classe</p>
    </div>
  );
};
